package one.healthium.base.launcher

import androidx.compose.runtime.Composable

@Composable
actual fun createPlatformLauncher(): PlatformLauncher {
    return PlatformLauncher()
}